<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Listagem das Solicitações AIDF.</span>
                <br />
                <span class="navigation">Solicitações > AIDF</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 mb-2">
              <label for="filtro">Filtro:</label>
              <span class="p-fluid">
                <InputText type="text" id="filtro" v-model="filtro" />
              </span>
            </div>
            <div style="margin-top:27px" class="col-md-3 col-lg-2 mb-3">
              <span class="p-fluid">
                <Calendar id="dataIni" name="dataFim" v-model="dataSolicitacaoIni" :showIcon="true"
                  dateFormat="dd/mm/yy" placeholder="Data Inicial" @keyup.enter="pesquisar" v-maska="'##/##/####'" />
              </span>
            </div>
            <div style="margin-top:27px" class="col-md-3 col-lg-2 mb-3">
              <span class="p-fluid">
                <Calendar id="dataFim" name="dataFim" v-model="dataSolicitacaoFim" :showIcon="true"
                  dateFormat="dd/mm/yy" placeholder="Data Final" @keyup.enter="pesquisar" v-maska="'##/##/####'" />
              </span>
            </div>
            <div style="margin-top:27px" class="col-md-3 col-lg-2 mb-2">
              <span class="p-fluid">
                <Dropdown id="situacao" v-model="filtroSituacao" :options="filtroSituacoes" optionLabel="name"
                  placeholder="Selecione uma Situação" />
              </span>
            </div>
          </div>
          <div class="row">
            <div class="mb-2">
              <label for="btnSearch">&nbsp;</label>
              <span class="p-fluid">
                <Button label="Pesquisar" title="Pesquisar" icon="pi pi-search" :disabled="search"
                  @click="pesquisar()" />
              </span>
            </div>
            <div class="mb-2" style="padding-left:2px">
              <label for="btnSearch">&nbsp;</label>
              <span class="p-fluid">
                <Button label="Limpar" title="Limpar" icon="pi pi-trash" :disabled="search" @click="clear()" />
              </span>
            </div>
          </div>
          <div class="row">
            <DataTable :value="aidfList" :paginator="true" :rows="10" class="p-datatable-responsive" :autoLayout="true">
              <Column headerStyle="width: 8em" bodyStyle="text-align: center">
                <template #body="slotProps">
                  <Button type="button" icon="pi pi-angle-down" style="margin-right: .5em"
                    @click="openAcaoAidf(slotProps.data.id)" v-if="admin"
                    :disabled="slotProps.data.situacaoFormatada != 'Solicitado'"></Button>
                  <Button type="button" icon="pi pi-pencil" style="margin-right: .5em"
                    @click="detail(slotProps.data.id)"
                    :disabled="slotProps.data.situacaoFormatada != 'Solicitado'"></Button>
                </template>
              </Column>
              <Column field="numeroAidf" header="Número AIDF"></Column>
              <Column field="contribuinte" header="Contribuinte"></Column>
              <Column field="dataEmissaoFormatada" header="Data"></Column>
              <Column field="situacaoFormatada" header="Situação"></Column>
              <Column field="observacoes" header="Observações"></Column>
            </DataTable>
          </div>
          <hr />

          <div class="row">
            <span class="p-fluid mr-2">
              <router-link to="/aidfCadastro">
                <Button type="button" icon="pi pi-plus" label="Novo" title="Novo" />
              </router-link>
            </span>
          </div>
        </div>
      </div>
    </div>
    <Dialog header="Aviso" :visible.sync="display" :style="{ width: '35vw', maxWidth: '100%' }" :modal="true">
      <div class="col-md-12 mb-2">
        <label for="observacao">Observações:</label>
        <span class="p-fluid">
          <textarea v-model="observacao" rows="5" maxlength="255" style="width: 100%;" />
        </span>
      </div>
      <hr />
      Qual ação deseja executar para a solicitação da AIDF?
      <div class="container">
        <div class="row">
          <div>
            <Button class="p-button-success mr-2" @click="acaoAidf('A', observacao)" label="Aceitar" icon="pi pi-check"
              title="Aceitar" />
          </div>

          <div>
            <Button label="Aceitar Parcial" @click="acaoAidf('P', observacao)" icon="pi pi-check"
              title="Aceitar Parcial" class="mr-2"/>
          </div>

          <div>
            <Button label="Recusar" icon="pi pi-times" @click="acaoAidf('R', observacao)" title="Recusar"
              class="p-button-danger mr-2" />
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import LoginService from "../services/acesso/login.service";
import AidfService from "../services/nfse/aidf.service";

export default {
  name: "aidfConsulta",
  data() {
    return {
      loading: false,
      display: false,
      search: false,
      exibirBotaoPrimeiroAcesso: null,
      currentUser: null,
      filtro: "",
      aidfList: [],
      aidfId: null,
      admin: 'N',
      observacao: "",
      dataSolicitacaoIni: null,
      dataSolicitacaoFim: null,
      filtroSituacao: null,
      filtroSituacoes: [
        { name: "Todos", key: "T" },
        { name: "Solicitado", key: "S" },
        { name: "Autorizado", key: "A" },
        { name: "Autorizado Parcial", key: "P" },
        { name: "Recusado", key: "R" },
      ],
    };
  },
  created() {
    this.currentUser = LoginService.currentUserValue;
    //só possibilitara a edição se o parametro admin tiver na url usuarios estão indevidamente bloqueando os grupos
    // this.admin = (this.$route.query.admin != null && this.$route.query.admin != '' ? this.$route.query.admin : 'N');
    this.admin = this.currentUser.usuario.idBolAdmin;
    this.pesquisar();
  },
  methods: {
    clear() {
      this.filtro = "";
      this.pesquisar();
    },
    pesquisar() {
      if (!this.dataSolicitacaoIni) {
        this.dataSolicitacaoIni = null;
      }
      if (!this.dataSolicitacaoFim) {
        this.dataSolicitacaoFim = null;
      }
      this.search = true;
      if (this.admin) {
        AidfService.findIdfByFiltroAdmin(
          this.currentUser.usuario.idCliente,
          this.filtro,
          (this.filtroSituacao ? this.filtroSituacao.key : "T"),
          this.dataSolicitacaoIni,
          this.dataSolicitacaoFim
        ).then(
          aidf => {
            this.aidfList = aidf.data;
          },
          error => {
            let errorMessage = "Houve um problema listar as Solicitações AIDF!";
            if (error.response) {
              errorMessage = error.response.data;
            }
            this.$toast.add({
              severity: "error",
              summary: errorMessage
            });
          }
        );
        this.search = false;
      } else {
        AidfService.findIdfByFiltro(
          this.currentUser.contribuinte.idContribuinte,
          this.filtro,
          (this.filtroSituacao ? this.filtroSituacao.key : "T"),
          this.dataSolicitacaoIni,
          this.dataSolicitacaoFim
        ).then(
          aidf => {
            this.aidfList = aidf.data;
          },
          error => {
            let errorMessage = "Houve um problema listar as Solicitações AIDF!";
            if (error.response) {
              errorMessage = error.response.data;
            }
            this.$toast.add({
              severity: "error",
              summary: errorMessage
            });
          }
        );
        this.search = false;
      }
    },
    detail(aidfId) {
      this.$router.push({ name: "aidfCadastro", params: { id: aidfId } });
    },
    openAcaoAidf(aidfId) {
      this.aidfId = aidfId;
      this.display = true;
    },
    close() {
      this.aidfId = null;
      this.display = false;
    },
    acaoAidf(situacao, observacao) {
      console.log("id: " + this.aidfId);
      AidfService.saveSituacaoAidf(
        this.aidfId,
        situacao,
        observacao
      ).then(
        aidf => {
          console.log(aidf.data);
          this.display = false;
          this.pesquisar();
        },
        error => {
          let errorMessage = "Houve um problema atualizar a solicitação AIDF!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
    },
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    }
  }
};
</script>

<style scoped>
.p-dialog-content {
  overflow: hidden !important;
  padding-right: 0;
  padding: 0.5rem;
}
</style>